import React from "react";
import Sale from "../../../components/lo5d/mobile/Sale";
import MainDrawingWrapper from "../../../components/lo5d/MainDrawingWrapper";

class Lotto5DMobile extends React.Component {

    render() {
        return (
            <div className="main-w">
                <div className="main">
                    <div className="w-1200">
                        <div className="wrapper-new-lotto5-mobile lotto5">
                            <MainDrawingWrapper>
                                <Sale />
                            </MainDrawingWrapper>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


export default Lotto5DMobile;
